module.exports = {"440232100":"乳城镇","440232103":"一六镇","440232104":"桂头镇","440232106":"洛阳镇","440232108":"大布镇","440232109":"大桥镇","440232111":"东坪镇","440232112":"游溪镇","440232113":"必背镇","440232450":"天井山林场","440232451":"乳阳林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440232.json
// module id = 1962
// module chunks = 0